import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

interface StockActionsProps {
  onOpenCart: () => void;
}

export const StockActions = ({ onOpenCart }: StockActionsProps) => {
  return (
    <Button
      onClick={onOpenCart}
      className="bg-blue-600 hover:bg-blue-700"
    >
      <ShoppingCart className="mr-2 h-4 w-4" />
      Voir le panier
    </Button>
  );
};